export default {
    name: "search",

    init() {
        const items = document.querySelectorAll('.js_show-more-results');

        items.forEach((i) => { i.addEventListener('click', (event) =>{
                if (typeof event.target.dataset['section'] === 'string') {
                    const section = '#section-' + event.target.dataset['section'];
                    const sectionEl = document.querySelector(section);
                    sectionEl.classList.remove('closed');
                    sectionEl.classList.add('open');
                }
            });
        });
    },
};
